import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { SkillsGrid } from '../components/sections/SkillsGrid';
export function SkillsPage() {
  return <div data-id="element-263" data-mp="1rr8e1k7z9bic">
      <PageHeader eyebrow="Skills" title="Functional & Executive Competencies" description="Functional, operational, and executive competencies across four disciplines." data-id="element-264" data-mp="1rri4ta0ujmp3" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-265" data-mp="1i1osg6svr3js">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-266" data-mp="1hzu56lu4yzcj">
          <SkillsGrid data-id="element-267" data-mp="1msn957hs63nk" />
        </div>
      </section>
    </div>;
}